import React from 'react';

export default class NotFound extends React.Component {
	render() {
		return <h1>Not Found {this.location}</h1>;
	}
}
